import { NgModule } from '@angular/core';
import { EmailShareModalComponent } from './email-share-modal.component';
import { CommonModule } from '@angular/common';
import { LoaderModule } from '../../../../components/loader/loader.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputModule } from '../../../../components/forms/input/input.module';
import { RecaptchaModule } from '../../../../components/recaptcha/recaptcha.module';
import { SwitchModule } from '../../../../components/forms/switch/switch.module';

@NgModule({
  imports: [
    CommonModule,
    LoaderModule,
    LazyLoadImageModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    InputModule,
    RecaptchaModule,
    SwitchModule
  ],
  declarations: [
    EmailShareModalComponent
  ],
  exports: [
    EmailShareModalComponent
  ]
})
export class EmailShareModalModule { }
